export default "__VITE_ASSET__CH4OdtF0__"